module.exports = __webpack_public_path__ + "img/it-service-04.86a9dbe1.webp";